export default __webpack_public_path__ + "static/media/undraw_online.bc1dbb3f.svg";